import React from 'react';
import { TEXTS } from "../constants/texts";

const ConfidentialMessage:  React.FC = () => {
  return (
    <div className="centered-wrapper">
        <strong> {TEXTS.confidentialDocument} </strong>
    </div>
  );
};

export default ConfidentialMessage;
